import request from '@/utils/request'

const creditLetterApi = {
  trade_credit_letter_list: '/trade/credit_letter/',
  trade_credit_letter_create: '/trade/credit_letter/',
  trade_credit_letter_update: '/trade/credit_letter/',
  trade_credit_letter_delete: '/trade/credit_letter/',
  trade_credit_letter_archived: '/trade/credit_letter_archived/',
  trade_lc_application_list: '/trade/lc_application/',
  trade_lc_application_create: '/trade/lc_application/',
  trade_lc_application_update: '/trade/lc_application/',
  trade_lc_application_delete: '/trade/lc_application/',
  trade_lc_issuance_list: '/trade/lc_issuance/',
  trade_lc_issuance_create: '/trade/lc_issuance/',
  trade_lc_issuance_update: '/trade/lc_issuance/',
  trade_lc_issuance_delete: '/trade/lc_issuance/',
  trade_lc_issuance_attachment_list: '/trade/lc_issuance_attachment/',
  trade_lc_issuance_attachment_create: '/trade/lc_issuance_attachment/',
  trade_lc_issuance_attachment_delete: '/trade/lc_issuance_attachment/',
  trade_lc_acceptance_list: '/trade/lc_acceptance/',
  trade_lc_acceptance_create: '/trade/lc_acceptance/',
  trade_lc_acceptance_update: '/trade/lc_acceptance/',
  trade_lc_cost_list: '/trade/lc_cost/',
  trade_lc_cost_create: '/trade/lc_cost/',
  trade_lc_cost_update: '/trade/lc_cost/',
  trade_lc_application_attachment_list: '/trade/lc_application_attachment/',
  trade_lc_application_attachment_create: '/trade/lc_application_attachment/',
  trade_lc_application_attachment_delete: '/trade/lc_application_attachment/'
}

/**
 * 列表
 */
export function credit_letter_list (parameter) {
  return request({
    url: creditLetterApi.trade_credit_letter_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function credit_letter_create (parameter) {
  return request({
    url: creditLetterApi.trade_credit_letter_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function credit_letter_update (parameter, credit_letter_id) {
  return request({
    url: creditLetterApi.trade_credit_letter_update + credit_letter_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function credit_letter_delete (credit_letter_id) {
  return request({
    url: creditLetterApi.trade_credit_letter_delete + credit_letter_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function credit_letter_archived (parameter) {
  return request({
    url: creditLetterApi.trade_credit_letter_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 列表
 */
export function lc_application_list (parameter) {
  return request({
    url: creditLetterApi.trade_lc_application_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    timeout: 60000,
    params: parameter
  })
}
/**
 * 添加
 */
export function lc_application_create (parameter) {
  return request({
    url: creditLetterApi.trade_lc_application_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 修改
 */
export function lc_application_update (parameter, lca_id) {
  return request({
    url: creditLetterApi.trade_lc_application_update + lca_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    timeout: 60000,
    data: parameter
  })
}
/**
 * 删除
 */
export function lc_application_delete (lca_id) {
  return request({
    url: creditLetterApi.trade_lc_application_delete + lca_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 列表
 */
export function lc_issuance_list (parameter) {
  return request({
    url: creditLetterApi.trade_lc_issuance_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 添加
 */
export function lc_issuance_create (parameter) {
  return request({
    url: creditLetterApi.trade_lc_issuance_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 修改
 */
export function lc_issuance_update (parameter, id) {
  return request({
    url: creditLetterApi.trade_lc_issuance_update + id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 删除
 */
export function lc_issuance_delete (id) {
  return request({
    url: creditLetterApi.trade_lc_issuance_delete + id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 列表
 */
export function lc_issuance_attachment_list (parameter) {
  return request({
    url: creditLetterApi.trade_lc_issuance_attachment_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 添加
 */
export function lc_issuance_attachment_create (parameter) {
  return request({
    url: creditLetterApi.trade_lc_issuance_attachment_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 删除
 */
export function lc_issuance_attachment_delete (id) {
  return request({
    url: creditLetterApi.trade_lc_issuance_attachment_delete + id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 列表
 */
export function lc_acceptance_list (parameter) {
  return request({
    url: creditLetterApi.trade_lc_acceptance_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function lc_acceptance_create (parameter) {
  return request({
    url: creditLetterApi.trade_lc_acceptance_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 添加
 */
export function lc_acceptance_update (parameter, id) {
  return request({
    url: creditLetterApi.trade_lc_acceptance_update + id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function lc_cost_list (parameter) {
  return request({
    url: creditLetterApi.trade_lc_cost_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 添加
 */
export function lc_cost_create (parameter) {
  return request({
    url: creditLetterApi.trade_lc_cost_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 修改
 */
export function lc_cost_update (parameter, id) {
  return request({
    url: creditLetterApi.trade_lc_cost_update + id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 列表
 */
export function lc_application_attachment_list (parameter) {
  return request({
    url: creditLetterApi.trade_lc_application_attachment_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

export function lc_application_attachment_create (parameter) {
  return request({
    url: creditLetterApi.trade_lc_application_attachment_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 删除
 */
export function lc_application_attachment_delete (id) {
  return request({
    url: creditLetterApi.trade_lc_application_attachment_delete + id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
